import {
  useCreateBedMutation,
  useDeleteBedMutation,
  useGetAllBedsQuery,
  useUpdateBedMutation,
} from "../../../services/api/locationsApi";
import { RoomModel } from "app/services/api/types/locations/models/RoomModel";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { BedRequest } from "app/services/api/types/locations/requests/BedRequest";
import { FloorModel } from "app/services/api/types/locations/models/FloorModel";

interface Props {
  floor?: FloorModel;
  room?: RoomModel;
}
export const useBedManagement = ({ floor, room }: Props) => {
  const { showErrorToast } = useDisplayToast();

  const [triggerCreateBed] = useCreateBedMutation();
  const [triggerUpdateBed] = useUpdateBedMutation();
  const [triggerDeleteBed] = useDeleteBedMutation();

  const { data: beds, isFetching } = useGetAllBedsQuery(
    { filter: { room_id: room?.id } },
    { skip: !room?.id || !floor?.id },
  );

  const handleCreateBed = async (data: BedRequest) => {
    try {
      await triggerCreateBed(data).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  const handleUpdateBed = async (bedId: number, data: BedRequest) => {
    try {
      await triggerUpdateBed({ bedId, body: data }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  const handleDeleteBed = async (bedId: number) => {
    try {
      await triggerDeleteBed({ bedId }).unwrap();
    } catch (e) {
      showErrorToast(e);
    }
  };

  return {
    beds: !room?.id || !floor?.id ? [] : beds,
    createBed: handleCreateBed,
    updateBed: handleUpdateBed,
    deleteBed: handleDeleteBed,
    areBedsFetching: isFetching,
  };
};
